export const APP_NAME = 'store_builder_perseus';
